/* eslint-disable react/prop-types */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { TelemetryImage } from './telemetryImage';
export const Card = ({ logoURL, title, subtitle, children })=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "card ms-depth-8",
        children: [
            logoURL && /*#__PURE__*/ _jsx("div", {
                className: "iconHost ms-depth-8",
                children: /*#__PURE__*/ _jsx(TelemetryImage, {
                    src: logoURL,
                    className: "appLargeIcon",
                    itemPropName: "image",
                    title: title
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "header",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "titleBlock",
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: "ms-fontSize-28 ms-fontWeight-semibold title",
                            children: title
                        }),
                        /*#__PURE__*/ _jsx("h2", {
                            className: "ms-fontSize-14 subTitle",
                            children: subtitle
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "mainContent",
                            children: children
                        })
                    ]
                })
            })
        ]
    });
};
